import React, {createContext, useContext, useEffect, useState} from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import {resolveTenant} from './api';
import Spinner from './components/Spinner';
import JobBoard from './pages/JobBoard';
import JobDetail from './pages/JobDetail';
import Applied from './pages/Applied';
import RequestLink from './pages/RequestLink';
import Portal from './pages/Portal';
import NotFound from './pages/NotFound';

export const TenantContext = createContext(null);
export function useTenant() { return useContext(TenantContext); }

function TenantGate({children}) {
  const [tenant, setTenant] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    resolveTenant().then(t => {
      if (t) setTenant(t);
      else setError(true);
    });
  }, []);

  if (error) return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center fade-in">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Organization Not Found</h1>
        <p className="text-gray-500">This subdomain is not associated with any organization.</p>
      </div>
    </div>
  );

  if (!tenant) return <Spinner className="min-h-screen" />;

  return <TenantContext.Provider value={tenant}>{children}</TenantContext.Provider>;
}

export default function App() {
  return (
    <Router>
      <TenantGate>
        <Routes>
          <Route path="/" element={<JobBoard />} />
          <Route path="/jobs/:id" element={<JobDetail />} />
          <Route path="/applied" element={<Applied />} />
          <Route path="/check-status" element={<RequestLink />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </TenantGate>
    </Router>
  );
}
